import { isNonOccupyingReservation } from "./reservationOccupancy";

const normalizePositiveId = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) && numeric > 0 ? numeric : null;
};

const normalizeDateOnly = (value) => {
  const match = String(value || "").match(/^(\d{4}-\d{2}-\d{2})/);
  return match ? match[1] : "";
};

const staysOverlap = (leftStart, leftEnd, rightStart, rightEnd) => {
  const normalizedLeftStart = normalizeDateOnly(leftStart);
  const normalizedLeftEnd = normalizeDateOnly(leftEnd);
  const normalizedRightStart = normalizeDateOnly(rightStart);
  const normalizedRightEnd = normalizeDateOnly(rightEnd);

  if (
    !normalizedLeftStart ||
    !normalizedLeftEnd ||
    !normalizedRightStart ||
    !normalizedRightEnd
  ) {
    return false;
  }

  return (
    normalizedLeftStart < normalizedRightEnd &&
    normalizedLeftEnd > normalizedRightStart
  );
};

export const reconcileDraftGroupRoomOptions = ({
  availableRooms = [],
  occupiedRooms = [],
  reservations = [],
  currentReservationId,
  checkInDate,
  checkOutDate,
} = {}) => {
  const normalizedCurrentReservationId = normalizePositiveId(
    currentReservationId
  );
  const siblingAssignedRoomIds = new Set();

  (Array.isArray(reservations) ? reservations : []).forEach((reservation) => {
    const reservationId = normalizePositiveId(reservation?.id);
    if (
      isNonOccupyingReservation(reservation) ||
      (normalizedCurrentReservationId &&
        reservationId === normalizedCurrentReservationId) ||
      !staysOverlap(
        reservation?.check_in_date,
        reservation?.check_out_date,
        checkInDate,
        checkOutDate
      )
    ) {
      return;
    }

    const roomId = normalizePositiveId(reservation?.room_id);
    if (roomId) siblingAssignedRoomIds.add(roomId);
  });

  const normalizedAvailableRooms = Array.isArray(availableRooms)
    ? availableRooms
    : [];
  const normalizedOccupiedRooms = Array.isArray(occupiedRooms)
    ? occupiedRooms
    : [];
  const occupiedById = new Map();

  normalizedOccupiedRooms.forEach((room) => {
    const roomId = normalizePositiveId(room?.id);
    if (roomId && !occupiedById.has(roomId)) occupiedById.set(roomId, room);
  });

  const nextAvailableRooms = [];
  normalizedAvailableRooms.forEach((room) => {
    const roomId = normalizePositiveId(room?.id);
    if (roomId && siblingAssignedRoomIds.has(roomId)) {
      if (!occupiedById.has(roomId)) occupiedById.set(roomId, room);
      return;
    }
    nextAvailableRooms.push(room);
  });

  return {
    availableRooms: nextAvailableRooms,
    occupiedRooms: [...occupiedById.values()],
  };
};
